module.exports = __webpack_public_path__ + "static/img/vodeoContainerBg.0dd60472.png";